<template>
  <body>
    <base-card>
      <Dots />
      <h1 class="showcase-name">Mansur</h1>

      <!-- Main Content -->
      <main class="container">
        <div class="section-title">
          <h2 class="section-title__heading">Bio</h2>
          <p class="section-title__subtitle">
            Let's get acquainted!
          </p>
        </div>

        <div class="grid bio">
          <div class="bio__position">
            <p>
              Web Developer <br />
              Student
            </p>
          </div>
          <div class="bio__content paragraph">
            <p>
              Hi! My name is Mansurjon Isakov, and almost everywhere on the
              Internet, you'll find me as MansurIsakov. I was born in
              Uzbekistan, in the very cool city of
              <a
                href="https://www.google.com/search?gs_ssp=eJzj4tTP1TcwMclIMjJg9GJPSy1KT8xLBAA3iAXJ&q=fergana&oq=ferg&aqs=chrome.1.69i57j46i512l2j0i512l2j46i512j46i175i199i512j69i60.1569j0j7&sourceid=chrome&ie=UTF-8"
                target="blank"
                class="link"
                >Fergana.</a
              >
              In 2020 I moved to Tashkent. Currently, I am studying at
              Westminster International University in Tashkent.
            </p>
            <br />

            <p>
              At the end of 2020, I started my journey in the world of
              programming. I used to work a lot with HTML, CSS, and JavaScript
              gaining experience by building brand new websites. I also
              co-founded
              <a
                href="https://it-house-llc.netlify.app/"
                target="blank"
                class="link"
                >IT House LLC.</a
              >
              Presently, I am coding a lot to become a Full-Stack Developer.
            </p>
            <br />

            <div>
              <p>In terms of skills, I am familiar with:</p>
              <ul class="bio__skills">
                <li class="bio__skills--item">
                  <span>HTML</span> - BEM Methodology, Dynamic Template Engines,
                  Pixel-Perfect Development, Semantic Developement.
                </li>
                <li class="bio__skills--item">
                  <span>CSS</span> - SASS, Flexbox / Grid / Float, Bootstrap,
                  Tailwind CSS, Adaptive / Responsive Development, 7 in 1
                  Architecture.
                </li>
                <li class="bio__skills--item">
                  <span>JavaScript</span> - DOM Manipulation, Asynchronous
                  Programming, OOP, npm / node modules, Modern JavaScript.
                </li>
                <li class="bio__skills--item">
                  <span>Vue</span> - Vue Syntax, Vue CLI, Vuex, Router, Vue
                  Components.
                </li>
              </ul>
            </div>
            <br />

            <p>
              I am a very friendly and easy-going introvert 🙈. <br />
              So yes, please,
              <a class="link" @click="goFindMe" target="blank">do find me.</a>
            </p>
            <br />
          </div>
        </div>
      </main>
      <!-- End Main Content -->
    </base-card>
  </body>
</template>

<script>
import Dots from "@/components/Dots.vue";

export default {
  name: "Home",
  components: {
    Dots,
  },
  methods: {
    goFindMe() {
      this.$router.push({ name: "FindMe" });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
// Section Settings
h1 {
  background-color: var(--tertiary-color);
}
.bg {
  background-color: var(--primary-color);
}
// End Section Settings

// Section Title
.section-title {
  &__heading {
    color: var(--tertiary-color);
  }
  &__subtitle {
    color: var(--secondary-color);
  }
}
// End Section Title

// Content
.grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
}
.bio {
  &__position {
    font-family: "Anton", sans-serif;
    font-size: 39px;
    color: var(--tertiary-color);
    text-align: right;
    margin-right: 15px;
  }
  &__content {
    border-left: 3px solid var(--secondary-color);
    padding-left: 15px;
  }
  &__skills {
    &--item {
      font-size: 16px;

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }

    &--item:not(:last-child) {
      margin-bottom: 5px;
    }
  }
}
// End Content

/* Adaptives */
@media only screen and (max-width: 64em) {
  .grid {
    grid-template-columns: 1fr;
  }
  .bio {
    &__position {
      font-size: 35px;
      text-align: left;
      margin-right: 0;
    }
    &__content {
      border-left: none;
      padding-left: 0px;
      margin-top: 10px;
    }
    &__skills {
      &--item {
        font-size: 14px;

        span {
          font-size: 16px;
        }
      }
    }
  }
}
/* End Adaptives */
</style>
